export default __webpack_public_path__ + "static/media/human.d43a9a86.svg";